import BookUtils from "../../../utils/book-utils";
import { removeDuplicates } from "../../../utils/array-utils";

export default (
  isbn,
  from,
  to,
  copies,
  totalPagesPrinted,
  printLimit,
  lifetimePrintPageCount
) => {
  const fromIndex = BookUtils.getIndexFromLabel(isbn, from);
  const toIndex = BookUtils.getIndexFromLabel(isbn, to);
  let pages = BookUtils.getPageRangeFromIndex(isbn, fromIndex, toIndex + 1);
  pages = removeDuplicates(pages, page => page.label);
  const unprintedPages = pages.filter(page => page && !copies[page.label]);

  // Validate Page
  if (fromIndex === -1 || toIndex === -1) {
    return {
      error: {
        from: fromIndex === -1,
        to: toIndex === -1,
        reason: i18n.t("print.page-not-found"),
        level: "input",
        pages: []
      }
    };
  }

  // Validate Range
  if (!from || !to || fromIndex > toIndex || pages.length === 0) {
    return {
      error: {
        reason: i18n.t("print.invalid-range"),
        from: true,
        to: true,
        level: "form",
        pages: []
      }
    };
  }

  // Validate Lifetime Print Limit
  if (
    unprintedPages.length > 0 &&
    totalPagesPrinted + unprintedPages.length > lifetimePrintPageCount
  ) {
    return {
      error: {
        reason: i18n.t("print.exceeds-pub-limit"),
        from: true,
        to: true,
        level: "form",
        pages: unprintedPages
      }
    };
  }

  // Validate Print Limit
  if (printLimit !== -1 && pages.length > printLimit) {
    return {
      error: {
        from: true,
        to: true,
        level: "form",
        reason: i18n.t("print.exceeds-pg-limit", { limit: printLimit }),
        pages: unprintedPages
      }
    };
  }
  return { pages: unprintedPages };
};
